import crud from '@/crud/index/index'

import data from './data'
import methods from './methods'
import mounted from './mounted'

export default {
  data,
  methods,
  mounted,

  mixins: [crud],

  resourcePath: 'v1/search/professionals/agendaCompanyStatistic'
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/statistics/resources/index.js